import { IDocumentEditable } from "..";
import { instanceOfIFontSizeAutoAdjustable, IFontSizeAutoAdjustable } from "../../../../domain/document/items";

export class FontSizeInitializer {
  constructor(public source: IDocumentEditable) {
  }
  
  initialize(): void {
    for (let i = 0; i < this.source.itemSets.length; i++) {
      const items = this.source.itemSets[i].items
        .filter(instanceOfIFontSizeAutoAdjustable);
      this.initializeFontSizeToItems(items, i);
    }
  }

  private initializeFontSizeToItems(items: IFontSizeAutoAdjustable[], itemSetId: number): void {
    for (const item of items) {
      if (!item.enabledAutoAdjustFontSize) { continue; }
      // TODO: V1の仕様の確認
      // 一律ですべてのオブジェクトのフォントサイズを調整してしまってよいものかどうか・・
      // PDF生成時はバックエンドでフォントサイズを調整するので、V1に寄せるというよりは、そちらの実装に寄せたほうがよさそう
      const beforeSize = item.textStyle.displayFontSize;
      const cloned = item.clone() as IFontSizeAutoAdjustable;
      cloned.adjustFontSize();
      if (cloned.textStyle.displayFontSize === beforeSize) { continue; }
      this.source.updateItem(cloned, {
        itemSetId,
      });
    }
  }
}
